import { useCheckPatientMRNMutation } from "@/data/queries"
import { Patient } from "@/model/Patient"
import { Duration } from "@js-joda/core"
import { debounce as _debounce } from "lodash"
import { useMemo, useState } from "react"

type CheckPatientMRNProps = {
  debounce: Duration
  organizationId: string
  medicalRecordNumber: string
}

const useCheckPatientMRN = ({
  debounce,
  organizationId,
  medicalRecordNumber,
}: CheckPatientMRNProps) => {
  const {
    mutateAsync: checkPatientMRN,
    isPending: isCheckingPatientMRN,
    isError: isErrorCheckPatientMRN,
  } = useCheckPatientMRNMutation()
  const [patientWithMRN, setPatientWithMRN] = useState<Patient | null>(null)
  const duration = debounce.toMillis()

  const debouncedCheckMRN = useMemo(
    () =>
      _debounce(async (value: string) => {
        if (value === medicalRecordNumber) {
          setPatientWithMRN(null)
        } else {
          const patient = await checkPatientMRN({
            organizationId,
            medicalRecordNumber: value,
          })
          setPatientWithMRN(patient)
        }
      }, duration),
    [checkPatientMRN, medicalRecordNumber, organizationId, duration]
  )

  return {
    debouncedCheckMRN,
    patientWithMRN,
    isCheckingPatientMRN,
    isErrorCheckPatientMRN,
  }
}

export default useCheckPatientMRN
